export default __webpack_public_path__ + "static/media/icon-care-admin-patient-profiles-new.46b283e0.svg";